(function () {
    'use strict';

    var imageCutoutC = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/image-cutout.html',
        controllerAs: 'vm',
        bindings: {
            imagebox: '<',
            onChange: '&',
            onSave: '&',
        },

        controller: ['$scope', '$timeout', 'MessageService', 'MattingBgByKey', 'Gallery', '$uibModal',
            function ($scope, $timeout, MessageService, MattingBgByKey, Gallery, $uibModal) {
                var vm = this;
                var articleRequest = false;
                vm.isMobile = isMobile();
                vm.image = null;
                vm.domain = localStorage.getItem('editor-domain');
                vm.loading = false;
                function init() {
                    vm.loading = true;
                    Gallery.getOne({ id: vm.imagebox.resourceid }, function (res) {
                        console.log(vm.imagebox);
                        if(vm.imagebox.mattingMask){
                            vm.loading = false;
                            vm.image = {
                                angle: vm.imagebox.angle,
                                flip: vm.imagebox.flip,
                                source_key: vm.domain + res.data.identifier,
                                result_key: vm.imagebox.result,
                                mask_key: vm.imagebox.mattingMask,
                            };
                            $scope.editImage()
                            if(!vm.isMobile){
                                vm.onSave();
                            }
                            return;
                        }
                        MattingBgByKey.get({ qiniu_key: res.data.identifier }, function (res) {
                            if(!articleRequest){
                                if (res && res.data) {
                                    imageboxImgInit(function (obj) {
                                        res.data.angle = obj.angle;
                                        res.data.flip = false;
                                        if (res.data.source_key) { res.data.source_key = vm.domain + res.data.source_key }
                                        if (res.data.result_key) { res.data.result_key = vm.domain + res.data.result_key }
                                        if (res.data.mask_key) { res.data.mask_key = vm.domain + res.data.mask_key }
                                        vm.image = res.data;
                                        vm.onChange({ text: {
                                            result: res.data.result_key,
                                            mattingMask: res.data.mask_key,
                                            angle: res.data.angle,
                                            flip: res.data.flip,
                                        } })
                                        vm.loading = false;
                                    })
                                } else {
                                    vm.loading = false;
                                    $scope.hideImage()
                                    if (vm.isMobile) {
                                        MessageService.hint('抠图失败:' + res.message);
                                    } else {
                                        MessageService.error('抠图失败:' + res.message);
                                    }
                                }
                            }
                        }, function (err) {
                            vm.loading = false;
                            $scope.hideImage()
                            if (vm.isMobile) {
                                MessageService.hint('抠图失败:' + err.data.message);
                            } else {
                                MessageService.error('抠图失败:' + err.data.message);
                            }
                        });
                    })
                }
                vm.isShowImageMasking = false;
                vm.isEditImage = false;
                $scope.editImage = function () {
                    if(vm.loading){
                        return;
                    }
                    vm.isEditImage = true;
                    if (vm.isMobile) {
                        vm.isShowImageMasking = true;
                    } else {
                        $uibModal.open({
                            templateUrl: 'app/entities/components/controls/matting-modal.html',
                            controller: 'MattingModalController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false,
                            windowClass: 'matting-modal',
                            resolve: {
                                entity: function () {
                                    return {
                                        originalImage: vm.image.source_key,
                                        maskImage: vm.image.mask_key
                                    };
                                }
                            }
                        }).result.then(function (res) {
                            vm.isEditImage = false;
                            if (res) {
                                if(res === 'cancel'){
                                    return;
                                }
                                applyMattingResult(res);
                                $scope.saveImage()
                            } else {
                                $scope.hideImage()
                            }
                        });
                    }
                }
                function applyMattingResult(data) {
                    if (data && data.url) {
                        vm.image.result_key = data.url;
                        if (data.maskUrl) {
                            vm.image.mask_key = data.maskUrl;
                        }
                        return;
                    }
                }
                $scope.imageMaskingSave = function (data) {
                    vm.isEditImage = false;
                    applyMattingResult(data);
                    vm.isShowImageMasking = false;
                    $scope.saveImage()
                }
                $scope.imageMaskingClose = function () {
                    vm.isEditImage = false;
                    vm.isShowImageMasking = false;
                    $scope.hideImage()
                }
                $scope.hideImage = function () {
                    articleRequest = true;
                    vm.onSave({ text: {
                        result: vm.imagebox.image,
                        mattingMask: vm.imagebox.mattingMask,
                        angle: vm.imagebox.angle,
                        flip: vm.imagebox.flip,
                    } });
                }
                $scope.saveImage = function () {
                    if(vm.loading){
                        return;
                    }
                    vm.onSave({ text: {
                        result: vm.image.result_key,
                        mattingMask: vm.image.mask_key,
                        angle: vm.image.angle,
                        flip: vm.image.flip,
                    } });
                }
                $scope.exitView = function (e) {
                    if(vm.loading && vm.isMobile){
                        return;
                    }
                    e.stopPropagation();
                    e.preventDefault();
                    if (!vm.isEditImage) {
                        if (vm.isMobile) {
                            MessageService.minConfirm({
                                cancel: "取消抠图",
                                confirm: "应用",
                                msg: "是否应用抠图效果"
                            }, function () {
                                $scope.saveImage();
                            }, function () {
                                $scope.hideImage();
                            })
                        } else {
                            MessageService.confirm({
                                title: "提示",
                                cancel: "取消抠图",
                                confirm: "应用",
                                msg: "是否应用抠图效果"
                            }, function () {
                                $scope.saveImage();
                            }, function () {
                                $scope.hideImage();
                            })
                        }
                    }
                }

                function imageboxImgInit(callback){
                    $.ajax({
                        type: "GET",
                        url: vm.imagebox.image + "?imageInfo",
                        async: false,
                        success: function (va1) {
                            var angle = (vm.imagebox.angle + 360 - orientationInit1(va1.orientation).angle) % 360;
                            var obj = {}
                            if (vm.imagebox.flip) {
                                obj.angle = -angle;
                            }else{
                                obj.angle = angle;
                            }
                            callback(obj);
                        }
                    });
                }
                init();
            }]
    };

    angular
        .module('editorApp')
        .component('imageCutout', imageCutoutC);
})();
